import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const CalculatorBtn = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathnames = location.pathname
    .split("/emi-calculator")
    .filter((x) => x);

  return (
    <>

      {
        pathnames.length > 0 ? (
          <div
            className="calc-floating-btn"
            onClick={() => navigate('/emi-calculator')}
            title="Calculate your EMI"
          >
            <div className="calc-icon-wrapper">
              {/* SVG Calculator Icon */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
                <line x1="8" y1="6" x2="16" y2="6"></line>
                <line x1="16" y1="14" x2="16" y2="18"></line>
                <path d="M8 10h.01"></path>
                <path d="M12 10h.01"></path>
                <path d="M16 10h.01"></path>
                <path d="M8 14h.01"></path>
                <path d="M12 14h.01"></path>
                <path d="M8 18h.01"></path>
                <path d="M12 18h.01"></path>
              </svg>
            </div>
            <span className="calc-hover-text">EMI Calculator</span>
          </div>
        ) : ""}
    </>
  );
}

export default CalculatorBtn;